export const OPEN = 'OPEN';
export const RESOLVED = 'RESOLVED';
export const APPROVED = 'APPROVED';
